import { SENTRY_CONFIG } from '../../config';
import { createSentry } from '../../infra';

export const sentry = createSentry(SENTRY_CONFIG);
